import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input } from "reactstrap";
import Select from "react-select";
import { statesList } from "../users/stateList";
import notifications from "../../common/Components/Notifications/Notification";
import { updateOrganisation } from "../../Store/organisation/actions";
import {
  clearStudioProfileNudge,
  shouldShowStudioProfileNudge,
} from "../../helpers/studioSignupSession";

const OrgProfileCompleteModal = (props: any) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [pinCodeError, setPinCodeError] = useState("");
  const [form, setForm] = useState({
    address: "",
    city: "",
    state: null as any,
    pinCode: "",
    GST: "",
  });

  useEffect(() => {
    if (shouldShowStudioProfileNudge()) {
      setOpen(true);
    }
  }, []);

  const close = () => {
    clearStudioProfileNudge();
    setOpen(false);
  };

  const save = () => {
    let auth: any = {};
    try {
      auth = JSON.parse(localStorage.getItem("authUser") || "{}");
    } catch {
      auth = {};
    }
    const org = auth?.users?.organizationResponse;
    if (!org?._id) {
      close();
      return;
    }
    const pinCode = form.pinCode.trim();
    if (pinCode && !/^\d{6}$/.test(pinCode)) {
      setPinCodeError("Enter a 6-digit pincode, or leave it empty.");
      return;
    }
    setSaving(true);
    props.updateOrganisation(
      {
        id: org._id,
        name: org.name,
        phone: org.phone,
        address: {
          addressLane: form.address,
          city: form.city,
          state: form.state?.label || "",
          pinCode: pinCode ? Number(pinCode) : 0,
        },
        gst: form.GST.trim().toUpperCase(),
      },
      (res: any) => {
        setSaving(false);
        if (res?.success) {
          notifications({
            title: "Saved",
            message: "Organisation details updated.",
            type: "success",
          });
          close();
        } else {
          notifications({
            title: "Could not save",
            message: res?.message || "Try again from organisation profile.",
            type: "danger",
          });
        }
      }
    );
  };

  return (
    <Modal isOpen={open} toggle={close} className="public-site">
      <ModalHeader toggle={close}>Complete organisation details</ModalHeader>
      <ModalBody>
        <p className="mb-3">
          GST and address help catalogues and invoices. You can skip this and add them later.
        </p>
        <Label>Address</Label>
        <Input
          autoComplete="street-address"
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
          placeholder="Workshop or studio address"
        />
        <Label className="mt-2">City</Label>
        <Input
          autoComplete="address-level2"
          value={form.city}
          onChange={(e) => setForm({ ...form, city: e.target.value })}
          placeholder="City"
        />
        <Label className="mt-2">State</Label>
        <Select
          options={statesList}
          value={form.state}
          onChange={(value) => setForm({ ...form, state: value })}
          placeholder="Select state"
        />
        <Label className="mt-2">Pincode</Label>
        <Input
          inputMode="numeric"
          autoComplete="postal-code"
          maxLength={6}
          value={form.pinCode}
          invalid={Boolean(pinCodeError)}
          onChange={(e) => {
            setPinCodeError("");
            setForm({ ...form, pinCode: e.target.value.replace(/\D/g, "") });
          }}
          placeholder="6-digit pincode"
        />
        {pinCodeError && <p className="RequiredField mb-0">{pinCodeError}</p>}
        <Label className="mt-2">GST</Label>
        <Input
          autoCapitalize="characters"
          autoCorrect="off"
          value={form.GST}
          onChange={(e) => setForm({ ...form, GST: e.target.value })}
          placeholder="Optional"
        />
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={close} disabled={saving}>
          I&apos;ll do this later
        </Button>
        <Button
          className="loginBtn"
          style={{ width: "auto", minWidth: 160, marginTop: 0 }}
          onClick={save}
          disabled={saving}
        >
          {saving ? "Saving" : "Save details"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default connect(null, { updateOrganisation })(OrgProfileCompleteModal);
